// 计费分类管理

import { HttpReserveOrderList,HttpSureReserveOne,HttpCancelReserveOne, HttpReleaseNum} from '@/service/setting';
import TableList from "@components/templates/tablelist";
import comIndex from './update'
import comRelease from './release'
import { mapGetters } from 'vuex';

export default {
    mixins: [TableList],
    components: {
        comIndex,
        comRelease
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            spanTabs: { show: true },
            statusList:[
                { value: 0, label: '草稿', theme:'error'},
                { value: 10, label: '已预留', theme:'primary' },
                { value: 15, label: '部分预留', theme:'warning' },
                { value: 20, label: '已释放', theme:'success'},
                { value: 5, label: '已取消', theme:'error' },
            ],
        };
    },
    methods: {
        ajaxRequest: HttpReserveOrderList,
        spanAjaxRequest:HttpReleaseNum,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            const temptype = this.formData.search.EQ_type;
            switch (type) {
                case 'query':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "查看",
                        width: 1100,
                        component: "comIndex",
                        querytype: 'query',
                        showalert:1,
                        activeid: params,
                        showFooter:false,
                    };
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "settingReservedUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'add':
                    this.$router.push({
                        name: "settingReservedUpdate",
                        params: { type },
                    })
                    break;
                case 'edit':
                    this.$router.push({
                        name: 'settingReservedUpdate',
                        params: { type: "edit" },
                        query: { id: params},
                    });
                    break;
                case 'exportExcel':
                    // this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/ReserveOrder/export', this.formData, 'download');
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/ReserveOrder/export", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'post'
                        }
                    );
                    break;
                case 'sure':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "确认操作",
                        ajaxRequest: HttpSureReserveOne
                    }
                    break;
                case 'cancel':
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { id: params },
                        title: "取消操作",
                        formdata:[
                            {
                                label: "备注",
                                key: 'remark',
                                tag: 'vTextarea',
                                span: 24,
                                labelWidth: 60,
                                required:false,
                            },
                        ],
                        ajaxRequest: HttpCancelReserveOne
                    }
                    break;
                case 'reserved':
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: "释放预留",
                        width: 600,
                        component: "comRelease",
                        id:params.id,
                        itemList:params.reserveOrderItemList,
                        showFooter: false,
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            // console.log(row)
            const { id, reserveOrderStatus,reserveOrderItemList } = row;
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            },{
                label: '编辑',
                show: reserveOrderStatus == 0,
                params: id,
                operate: 'edit'
            },{
                label: '确认',
                show: reserveOrderStatus == 0,
                params: id,
                operate: 'sure'
            }, {
                label: '取消',
                show: reserveOrderStatus == 0,
                params: id,
                operate: 'cancel'
            },
            {
                label: '释放预留',
                show: reserveOrderStatus == 10 || reserveOrderStatus == 15,
                params: {id,reserveOrderItemList},
                operate: 'reserved'
            },
            
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList','getUserManageWarehouseList', 'getSelfmanageorgList', 'getBillcusWareList','getSysAllList']),
        TabsData() {
            return [
                {
                    name: "全部",
                    key: 'EQ_reserveOrderStatus',
                    val: null,
                    spanKey: 'allNum',
                }, {
                    name: "草稿",
                    key: 'EQ_reserveOrderStatus',
                    val: '0',
                    spanKey: 'draftNum',
                }, {
                    name: "已预留",
                    key: 'EQ_reserveOrderStatus',
                    val: '10',
                    spanKey: 'reserveNum',
                }, {
                    name: "部分预留",
                    key: "EQ_reserveOrderStatus",
                    val: '15',
                    spanKey: 'partReserveNum',
                }, {
                    name: "已释放",
                    key: "EQ_reserveOrderStatus",
                    val: '20',
                    spanKey: 'releaseNum',
                }
            ]
        },
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "导出",
                    operate: "exportExcel",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "预留单号",
                    key: 'EQ_reserveNo',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "来源单号",
                    key: 'EQ_sourceNo',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "状态",
                    key: 'IN_reserveOrderStatus',
                    show: true,
                    tag: 'vSelect',
                    options: this.statusList,
                    props: {
                        filterable: true,
                        multiple:true,
                    }
                },
                {
                    label: "库存类型",
                    key: 'EQ_inventoryType',
                    tag: 'vSelect',
                    options: [
                        { value: 0, label: '可售库存' },
                        { value: 1, label: '不可售库存' },
                    ],
                },
                {
                    label: "客户",
                    key: 'EQ_organizationId',
                    tag: 'vSelect',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "仓库",
                    key: 'EQ_orgWarehouseCode',
                    tag: 'vSelect',
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "SKU",
                    key: 'EQ_reserveOrderItemList.sku',
                    tag: 'vInput',
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '操作',
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: '客户',
                    key:'orgName',
                    // render: (h, { row }) => this.findRenderLabel(this.getSysAllList, row.organizationId),
                }, {
                    title: '预留单号/来源单号',
                    render: (h, { row,index }) => {
                        const className=`copy_${row.reserveNo}_${index}`
                        return <div>
                            <a class={className} onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.reserveNo || '--'}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            <div>{row.sourceNo || '--'}</div>
                        </div>
                    }
                }, {
                    title: '状态',
                    key: 'status',
                    render: (h, { row }) => this.findRenderLabel(this.statusList, row.reserveOrderStatus,'label',true),
                },
                // {
                //     title:'是否取消',
                //     key:'isCancelled',
                //     render: (h, { row }) => row.isCancelled == 1 ? '是' : '否',
                // },
                {
                    title: '库存类型',
                    key: 'inventoryType',
                    render: (h, { row }) => row.inventoryType == 1 ? '不可售' : '正常',
                }, {
                    title: '仓库',
                    key: 'orgWarehouseName',
                    // render: (h, { row }) => this.findRenderLabel(this.getUserManageWarehouseList, row.orgWarehouseCode),
                }, {
                    title: '更新时间',
                    key: 'createdAt',
                }];
        },
    },
};




